import { BaseService } from './base';
import { ApiRequest } from '../lib/request';
import type { ApiListResponse } from '../lib/response';
import { Voucher } from '../models/voucher';

export class VoucherService extends BaseService<Voucher> {
  override model = Voucher;
  override modelName = 'voucher';
  override modelLabel = 'Promo Code';

  async filter(
    page: number = 1,
    filter?: string,
  ): Promise<ApiListResponse<Voucher>> {
    const query: Record<string, string> = {
      page: page.toString(),
    };

    if (filter) {
      query.filter = filter;
    }

    const request = new ApiRequest({
      method: 'GET',
      url: this.modelBaseUrl,
      query,
    });

    return await this.requestList(request, Voucher);
  }

  async batchCreate(
    data: any[],
  ): Promise<ApiListResponse<Voucher>> {
    const request = new ApiRequest({
      method: 'POST',
      url: `${this.modelBaseUrl}/batch`,
      data,
    });

    return await this.requestList(request, Voucher);
  }
}
